import Raty from 'raty-js';
import Flickity from "flickity";

class Stars {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-stars="scope"]'
		}, config);

		this.$scope = $(this.config.scope);

		if(this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, scope) => {
			new Promise(resolve => {
				let $scope = $(scope);
				let settings = {
					readOnly: true,
					starHalf: '/image/star-half.svg',
					starOff: '/image/star-empty.svg',
					starOn: '/image/star.svg',
				}

				let raty = new Raty(scope, settings);
				raty.init();
				resolve($scope);
			}).then($scope => {
				this.reloadFlickityIfNeeded($scope);
			})
		});
	}

	reloadFlickityIfNeeded($scope) {
		let $flickity = $scope.closest('.flickity-carousel');
		if($flickity.length < 1) {
			return;
		}
		let flickity = Flickity.data($flickity[0]);
		flickity.resize();
	}
}

export default Stars;